module.exports = __webpack_public_path__ + "img/edit-icon.a7d222e6.svg";